module.exports = "<footer class=\"app-footer\">\n  <span class=\"brand\">By Cycloan</span>\n</footer>"